export const AppRoutes = {
  LOGIN: '/login',
  DASHBOARD: '/',
  DAILY_BRIEFING: '/daily-briefing',
  ACCESS_DENIED: '/access-denied',

  // ── Knowledge base ─────────────────────────────────────────────────────────
  HELP:       '/help',
  HELP_GUIDE: '/help/:slug',

  // Public mirror of the knowledge base. Deliberately OUTSIDE the authenticated tree: these are
  // the links you send to someone who has no myLedger account — a new hire before their user is
  // created, an auditor, a client's accountant. Same guides, no screen links, no data.
  KB_PUBLIC:       '/kb',
  KB_PUBLIC_GUIDE: '/kb/:slug',
  CHANGE_PASSWORD:  '/change-password',
  FORGOT_PASSWORD:  '/forgot-password',
  RESET_PASSWORD:   '/reset-password',

  // ── Masters ────────────────────────────────────────────────────────────────
  MST_CURRENCY:         '/masters/currency',
  MST_FINANCIAL_YEAR:   '/masters/financial-year',
  MST_FINANCIAL_PERIOD: '/masters/financial-period',
  MST_LOCATION:         '/masters/location',
  MST_COST_CENTER:      '/masters/cost-center',
  MST_EXCHANGE_RATE:    '/masters/exchange-rate',
  MST_BANK:             '/masters/bank',
  MST_BANK_BRANCH:      '/masters/bank-branch',

  // ── General Ledger ─────────────────────────────────────────────────────────
  GL_JOURNALS:          '/gl/journals',
  GL_JOURNAL_IMPORT:    '/gl/journals/import',
  GL_JOURNAL_NEW:       '/gl/journals/new',
  GL_JOURNAL_DETAIL:    '/gl/journals/:id',
  GL_APPROVAL_INBOX:    '/gl/approvals',
  GL_COA:               '/gl/chart-of-accounts',
  GL_PERIODS:           '/gl/periods',

  // ── Accounts Receivable ────────────────────────────────────────────────────
  AR_INVOICES:          '/ar/invoices',
  AR_INVOICE_NEW:       '/ar/invoices/new',
  AR_INVOICE_IMPORT:    '/ar/invoices/import',
  AR_INVOICE_DETAIL:    '/ar/invoices/:id',
  AR_RECEIPTS:          '/ar/receipts',
  AR_RECEIPT_NEW:       '/ar/receipts/new',
  AR_RECEIPT_DETAIL:    '/ar/receipts/:id',
  AR_CUSTOMERS:         '/ar/customers',
  AR_AGEING:            '/ar/ageing',
  AR_ALLOCATION:        '/ar/allocations',
  AR_ALLOCATION_NEW:    '/ar/allocations/new',
  AR_ALLOCATION_DETAIL: '/ar/allocations/:id',
  AR_OUTSTANDING:         '/ar/outstanding',
  AR_APPROVAL_INBOX:      '/ar/approval-inbox',
  AR_CUSTOMER_STATEMENT:  '/ar/customer-statement',

  // ── Accounts Payable ───────────────────────────────────────────────────────
  // ── Budgeting (422477) ─────────────────────────────────────────────────────
  BUDGET:               '/budget',
  BUDGET_VS_ACTUAL:     '/budget/vs-actual',

  AP_BILLS:             '/ap/bills',
  AP_BILL_NEW:          '/ap/bills/new',
  AP_BILL_IMPORT:       '/ap/bills/import',
  AP_BILL_DETAIL:       '/ap/bills/:id',
  AP_PAYMENTS:          '/ap/payments',
  AP_PAYMENT_NEW:       '/ap/payments/new',
  AP_PAYMENT_DETAIL:    '/ap/payments/:id',
  AP_SUPPLIERS:         '/ap/suppliers',
  AP_AGEING:            '/ap/ageing',
  AP_ALLOCATION:        '/ap/allocations',
  AP_ALLOCATION_NEW:    '/ap/allocations/new',
  AP_ALLOCATION_DETAIL: '/ap/allocations/:id',
  AP_OUTSTANDING:       '/ap/outstanding',
  AP_SUPPLIER_STATEMENT: '/ap/supplier-statement',
  AP_APPROVAL_INBOX:    '/ap/approval-inbox',

  // ── Finance — Open Items Inquiry ──────────────────────────────────────────
  FIN_OPEN_ITEMS:       '/fin/open-items',
  FIN_AGEING:           '/fin/ageing',

  // ── Banking & Cash ─────────────────────────────────────────────────────────
  BANK_ACCOUNTS:    '/banking/accounts',
  BANK_RECONCILE:        '/banking/reconcile',
  BANK_RECONCILE_NEW:    '/banking/reconcile/new',
  BANK_RECONCILE_DETAIL: '/banking/reconcile/:id',
  BANK_RECONCILE_REPORT: '/banking/reconcile-report',
  BANK_TRANSFERS:   '/banking/transfers',
  BNK_BANK_ACCOUNT: '/banking/accounts',   // alias — same path as BANK_ACCOUNTS

  BANK_TRANSFER_NEW:      '/banking/transfers/new',
  BANK_TRANSFER_DETAIL:   '/banking/transfers/:id',

  BANK_DEPOSITS:          '/banking/deposits',
  BANK_DEPOSIT_NEW:       '/banking/deposits/new',
  BANK_DEPOSIT_DETAIL:    '/banking/deposits/:id',
  CASH_DEPOSIT:           '/banking/cash-deposit',
  PETTY_CASH_FLOATS:      '/banking/petty-cash',
  PETTY_CASH_VOUCHERS:    '/banking/petty-cash/vouchers',
  PETTY_CASH_VOUCHER_NEW: '/banking/petty-cash/vouchers/new',
  PETTY_CASH_VOUCHER_DETAIL: '/banking/petty-cash/vouchers/:id',
  PETTY_CASH_REGISTER:    '/banking/petty-cash/register',
  PETTY_CASH_SUMMARY:     '/banking/petty-cash/summary',

  BANK_WITHDRAWALS:       '/banking/withdrawals',
  BANK_WITHDRAWAL_NEW:    '/banking/withdrawals/new',
  BANK_WITHDRAWAL_DETAIL: '/banking/withdrawals/:id',

  BANK_CHARGES:           '/banking/charges',
  BANK_CHARGE_NEW:        '/banking/charges/new',
  BANK_CHARGE_DETAIL:     '/banking/charges/:id',

  BANK_INTEREST:          '/banking/interest',
  BANK_INTEREST_NEW:      '/banking/interest/new',
  BANK_INTEREST_DETAIL:   '/banking/interest/:id',

  BANK_CHEQUES:           '/banking/cheques',
  BANK_CHEQUE_NEW:        '/banking/cheques/new',
  BANK_CHEQUE_DETAIL:     '/banking/cheques/:id',
  BANK_RETURNED_CHEQUES:  '/banking/returned-cheques',
  BANK_CHEQUE_PRINT_QUEUE:'/banking/cheque-print-queue',

  // ── Fixed Assets ───────────────────────────────────────────────────────────
  FA_REGISTER:      '/assets/register',
  FA_DEPRECIATION:  '/assets/depreciation',

  // ── Inventory ──────────────────────────────────────────────────────────────
  INV_ITEMS:        '/inventory/items',
  INV_MOVEMENTS:    '/inventory/movements',

  // ── Payroll ────────────────────────────────────────────────────────────────
  PAY_EMPLOYEES:    '/payroll/employees',
  PAY_RUNS:         '/payroll/runs',

  // ── Reports ────────────────────────────────────────────────────────────────
  REPORTS_TRIAL_BALANCE:  '/reports/trial-balance',
  REPORTS_ACCOUNT_LEDGER: '/reports/account-ledger',
  REPORTS_GL_INQUIRY:     '/reports/gl-inquiry',
  REPORTS_PL:             '/reports/profit-loss',
  REPORTS_BALANCE_SHEET:  '/reports/balance-sheet',
  REPORTS_CASH_FLOW:      '/reports/cash-flow',
  REPORTS_GENERAL_LEDGER: '/reports/general-ledger',
  REPORTS_CASH_BOOK:      '/reports/cash-book',
  REPORTS_BANK_BOOK:      '/reports/bank-book',
  REPORTS_DAY_BOOK:       '/reports/day-book',
  REPORTS_AGEING:         '/reports/ageing',
  REPORTS_GL_LEDGER:      '/reports/general-ledger-report',

  // ── Reporting Centre — reconciliation & control ───────────────────────────
  RC_SUBLEDGER_RECON:    '/reportcentre/subledger-recon',
  RC_CONTROL_EXCEPTIONS: '/reportcentre/control-exceptions',
  RC_SUSPENSE_CLEARING:  '/reportcentre/suspense-clearing',
  RC_TAX_GL_RECON:       '/reportcentre/tax-gl-recon',
  RC_SOURCE_TRACE:       '/reportcentre/source-trace',

  // ── Reporting Centre — period closing ─────────────────────────────────────
  RC_PERIOD_STATUS:      '/reportcentre/period-status',
  RC_YEAR_END:           '/reportcentre/year-end-report',

  // ── Reporting Centre — audit & compliance ─────────────────────────────────
  RC_AUDIT_TRAIL:        '/reportcentre/audit-trail',
  RC_JOURNAL_CHANGES:    '/reportcentre/journal-changes',
  RC_DELETED_CANCELLED:  '/reportcentre/deleted-cancelled',
  RC_USER_ACTIVITY:      '/reportcentre/user-activity',
  RC_APPROVAL_HISTORY:   '/reportcentre/approval-history',
  RC_UNUSUAL_JOURNALS:   '/reportcentre/unusual-journals',

  // ── Reporting Centre — currency & master data ─────────────────────────────
  RC_CURRENCY_REPORTS:   '/reportcentre/currency',
  RC_FS_MAPPING:         '/reportcentre/fs-mapping',
  RC_OFFSETTING:         '/reportcentre/offsetting',
  RC_WHT_REGISTER:       '/reportcentre/wht-register',

  // ── Management analytics ──────────────────────────────────────────────────
  ANALYTICS_EXEC_DASHBOARD:  '/analytics/executive-dashboard',
  ANALYTICS_PROFITABILITY:   '/analytics/profitability',
  ANALYTICS_EXPENSE:         '/analytics/expense-analysis',
  ANALYTICS_COST_CENTRE:     '/analytics/cost-centre-performance',
  ANALYTICS_TREND:           '/analytics/financial-trend',
  ANALYTICS_ACCOUNT_ACTIVITY:'/analytics/account-activity',
  ANALYTICS_JOURNAL_ANALYSIS:'/analytics/journal-analysis',
  ANALYTICS_SCORECARD:       '/analytics/scorecard',

  // ── Configuration / Setup ─────────────────────────────────────────────────
  CFG_TRANSACTION_TYPE: '/setup/transaction-types',
  CFG_DOC_NUMBERING:    '/setup/document-numbering',
  CFG_WORKFLOWS:        '/setup/workflows',
  CFG_WORKFLOW_NEW:     '/setup/workflows/new',
  CFG_WORKFLOW_DETAIL:  '/setup/workflows/:id',

  CASH_DENOM_SETUP:       '/setup/cash-denominations',
  PMT_METHOD_SETUP:       '/setup/payment-methods',
  CHEQUE_LAYOUT_SETUP:    '/setup/cheque-layouts',
  CHEQUE_BOOK_SETUP:      '/setup/cheque-books',
  AGEING_PROFILE_SETUP:   '/setup/ageing-profiles',
  RECON_TOLERANCE_SETUP:  '/setup/reconciliation-tolerances',

  // ── Administration ─────────────────────────────────────────────────────────
  ADMIN_USERS:         '/admin/users',
  ADMIN_USER_NEW:      '/admin/users/new',
  ADMIN_USER_DETAIL:   '/admin/users/:id',
  ADMIN_ROLES:         '/admin/roles',
  ADMIN_ROLE_NEW:      '/admin/roles/new',
  ADMIN_ROLE_DETAIL:   '/admin/roles/:id',
  ADMIN_COMPANY:          '/admin/company',
  ADMIN_PASSWORD_POLICY:  '/admin/password-policy',
  ADMIN_DEMO_RESET:       '/admin/demo-reset',
  ADMIN_SAMPLE_DATA:       '/admin/sample-data',
  ADMIN_SAMPLE_DATA_GUIDE: '/admin/sample-data/guide',
  ADMIN_SESSIONS:         '/admin/sessions',
  ADMIN_EMAIL_SETTINGS:   '/admin/email-settings',
  ADMIN_SYSTEM_LOGS:      '/admin/system-logs',
  ADMIN_SECURITY_AUDIT:   '/admin/security-audit',
  ADMIN_AUDIT:            '/admin/audit-log',
  ADMIN_SETTINGS:         '/admin/settings',

  // ── Governance / Policy Engine ─────────────────────────────────────────────
  ADMIN_POLICY_SETUP:       '/admin/policy-setup',
  ADMIN_POLICY_NEW:         '/admin/policy-setup/new',
  ADMIN_POLICY_DETAIL:      '/admin/policy-setup/:id',
  ADMIN_APPROVAL_LIMITS:    '/admin/approval-limits',
  ADMIN_WORKFLOW_POLICY:    '/admin/workflow-policy',

  // ── Finance Phase 2 ───────────────────────────────────────────────────────
  MONTH_END_CENTER:                '/finance/month-end',
  PERIOD_CLOSING_LIST:             '/finance/period-closing',
  PERIOD_CLOSING_NEW:              '/finance/period-closing/new',
  PERIOD_CLOSING_DETAIL:           '/finance/period-closing/:id',
  YEAR_END_CLOSE:                  '/finance/year-end-close',
  FX_REVALUATION:                  '/finance/fx-revaluation',
  RECURRING_JOURNALS_LIST:         '/finance/recurring-journals',
  RECURRING_JOURNAL_NEW:           '/finance/recurring-journals/new',
  RECURRING_JOURNAL_EDIT:          '/finance/recurring-journals/:id/edit',
  ACCRUALS_LIST:                   '/finance/accruals',
  ACCRUAL_NEW:                     '/finance/accruals/new',
  ACCRUAL_DETAIL:                  '/finance/accruals/:id',
  GL_ALLOCATION_TEMPLATES_LIST:    '/finance/gl-allocation-templates',
  GL_ALLOCATION_TEMPLATE_NEW:      '/finance/gl-allocation-templates/new',
  GL_ALLOCATION_TEMPLATE_EDIT:     '/finance/gl-allocation-templates/:id/edit',
  INTEGRATION_BATCHES_LIST:        '/integration/posting-batches',
  INTEGRATION_BATCH_DETAIL:        '/integration/posting-batches/:id',
  INTEGRATION_MAPPINGS:            '/integration/master-mappings',
  INTEGRATION_CLIENTS:             '/integration/api-keys',
  INTEGRATION_POSTING_RULES:       '/integration/posting-rules',
  INTEGRATION_RULE_LIBRARY:        '/integration/rule-library',
  INTEGRATION_QUARANTINE:          '/integration/quarantine',
  INTEGRATION_POSTING_ACCOUNTS:    '/integration/posting-accounts',
  INTEGRATION_POSTING_RULE_NEW:    '/integration/posting-rules/new',
  INTEGRATION_POSTING_RULE_EDIT:   '/integration/posting-rules/:id/edit',
  INTEGRATION_SETTINGS:            '/integration/settings',
  INTEGRATION_ONBOARDING:          '/integration/onboarding',
  INTEGRATION_ONBOARDING_TEMPLATES:'/integration/onboarding-templates',

  // ── Background Job Scheduler & ERP Operations ─────────────────────────────
  SCHEDULER_JOBS:       '/admin/scheduler/jobs',
  SCHEDULER_JOB_DETAIL: '/admin/scheduler/jobs/:id',
  SCHEDULER_SETTINGS:   '/admin/scheduler/settings',
  OPS_DASHBOARD:        '/ops/dashboard',
  OPS_JOB_HISTORY:      '/ops/job-history',

  // ── Notifications ─────────────────────────────────────────────────────────
  NOTIFICATIONS: '/notifications',

  CASH_RECONCILIATIONS:        '/banking/cash-reconciliations',
  CASH_RECONCILIATION_NEW:     '/banking/cash-reconciliations/new',
  CASH_RECONCILIATION_DETAIL:  '/banking/cash-reconciliations/:id',
  CASH_RECON:                  '/banking/cash-reconciliations',
  CASH_RECON_NEW:              '/banking/cash-reconciliations/new',
  CASH_RECON_DETAIL:           '/banking/cash-reconciliations/:id',
  CHEQUE_ISSUANCES:            '/banking/cheque-issuances',
  CHEQUE_ISSUANCE_DETAIL:      '/banking/cheque-issuances/:id',

  // ── Card Reconciliation ────────────────────────────────────────────────────
  CARD_ACQUIRERS:             '/banking/card-acquirers',
  CARD_CHARGEBACKS:           '/banking/card-chargebacks',
  CARD_ACQUIRER_NEW:          '/banking/card-acquirers/new',
  CARD_ACQUIRER_DETAIL:       '/banking/card-acquirers/:id',
  CARD_CLEARING_ITEMS:        '/banking/card-clearing-items',
  CARD_RECEIVABLES_AGEING:    '/banking/card-receivables-ageing',
  CARD_SETTLEMENTS:           '/banking/card-settlements',
  CARD_SETTLEMENT_DETAIL:     '/banking/card-settlements/:id',
  CARD_RECONCILIATIONS:       '/banking/card-reconciliations',
  CARD_RECONCILIATION_NEW:    '/banking/card-reconciliations/new',
  CARD_RECONCILIATION_DETAIL: '/banking/card-reconciliations/:id',

  // ── Tax Management ─────────────────────────────────────────────────────────
  TAX_JURISDICTIONS:         '/tax/jurisdictions',
  TAX_TYPES:                 '/tax/types',
  TAX_CODES:                 '/tax/codes',
  TAX_GROUPS:                '/tax/groups',
  TAX_WHT_RULES:             '/tax/withholding-rules',
  TAX_REGISTRATIONS:         '/tax/registrations',
  TAX_INQUIRY:               '/tax/inquiry',
  TAX_SUMMARY_REPORT:        '/reports/tax-summary',
  TAX_REGISTER_REPORT:       '/reports/tax-register',
} as const;
